module.exports = __webpack_public_path__ + "static/img/logo.fce8100d.svg";